import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

@Injectable({ providedIn: 'root' })
export class SocketLoggerService {
  constructor(private socket: Socket) {
    // Log ALL incoming events
    this.socket.ioSocket.onAny((event, ...args) => {
      console.log('[INCOMING]', event, args);
    });

    // Monkey-patch emit to log ALL outgoing events
    const originalEmit = this.socket.ioSocket.emit.bind(this.socket.ioSocket);
    this.socket.ioSocket.emit = (event: string, ...args: any[]) => {
      console.log('[OUTGOING]', event, args);
      return originalEmit(event, ...args);
    };
  }
}